module.exports = {["template-constructor-block-slideshow"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<input class="uploadInput" type="file" name="upload" multiple="multiple" data-url="/api/upload/" />\n	<div class="slideshow-overlay jsSlideshowOverlay"></div>\n\n	<div class="drop-text"></div>\n\n';
}
return __p;
},}